import actions from './actions';
import mutations from './mutations';
import getters from './getters';

import DEFAULT_STRUCT from './struct';

const state = {
  identity: DEFAULT_STRUCT,
  countries: [],
  identification: {
    status: null,
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
